import { render, staticRenderFns } from "./MyObjectIcon.vue?vue&type=template&id=9873acf8&"
import script from "./MyObjectIcon.vue?vue&type=script&lang=js&"
export * from "./MyObjectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports